import { KeyboardKeyEnum } from '@/React/Shared/Type/KeyboardKeyEnum'
import { useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import { FlashStatusTypeEnum } from '@/Shared/AutoGenerated/Main'
import { Icon, IconNameEnum } from '@/React/Shared/Component/Icon'
import { flashMessageStore } from '@/React/Shared/Component/Flash/FlashMessageStore'

export function FlashMessage() {
    const flashStatus = useSyncExternalStore(
        flashMessageStore.subscribe,
        flashMessageStore.getSnapshot,
        flashMessageStore.getSnapshot,
    )

    if (flashStatus === null) {
        return null
    }

    const isSuccess = flashStatus.type === FlashStatusTypeEnum.Success
    const flashClassName = isSuccess ? 'bg-emerald-600' : 'bg-red-700'
    const iconName = isSuccess
        ? IconNameEnum.CircleCheck
        : IconNameEnum.CloseCircle

    const role = isSuccess ? 'status' : 'alert'
    const ariaLive = isSuccess ? 'polite' : 'assertive'

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (
            e.key === KeyboardKeyEnum.Enter ||
            e.key === KeyboardKeyEnum.Space ||
            e.key === KeyboardKeyEnum.Escape
        ) {
            e.preventDefault()
            flashMessageStore.dismiss()
        }
    }

    return createPortal(
        <div
            role={role}
            aria-live={ariaLive}
            tabIndex={0}
            onClick={flashMessageStore.dismiss}
            onKeyDown={handleKeyDown}
            className="fixed top-4 right-4 z-100 max-w-xs cursor-pointer shadow-md md:max-w-md lg:max-w-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary rounded-xl"
        >
            <div
                className={`flex items-start gap-1 rounded-xl p-4 text-gray-50 ${flashClassName}`}
            >
                <Icon
                    name={iconName}
                    aria-hidden="true"
                    className="h-6 w-6 shrink-0"
                />
                <div>
                    <span>{flashStatus.message}</span>
                    <span className="sr-only">
                        {' '}
                        (Press Enter or Escape to dismiss)
                    </span>
                </div>
            </div>
        </div>,
        document.body,
    )
}
